"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LangUtils_1 = require("@twii/core/lib/LangUtils");
var setBoundValue = function (props, value) {
    var binding = props.binding;
    if (binding) {
        if (binding.setter) {
            if (LangUtils_1.isFunction(binding.setter)) {
                binding.setter(value);
            }
            else {
                var s = binding.target[binding.setter];
                s.call(binding.target, value);
            }
        }
        else {
            binding.target[binding.key] = value;
        }
    }
};
exports.setBoundValue = setBoundValue;
var getBoundValue = function (props) {
    var binding = props.binding;
    if (binding) {
        if (binding.getter) {
            if (LangUtils_1.isFunction(binding.getter)) {
                return binding.getter();
            }
            var s = binding.target[binding.getter];
            return s.call(binding.target);
        }
        return binding.target[binding.key];
    }
};
exports.getBoundValue = getBoundValue;
